import React, { useEffect, useState } from 'react';
import { JiraIssueTypeData, JiraSprintData, JiraUserLiteData } from '../../../api/endpoints/jira';
import { Input } from '../../../ui';
import { ButtonToggle } from '../../../ui/ButtonToggle';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { JiraProjectIssueTypeSelector } from '../../packages/atlassian/menus/JiraProjectIssueTypeSelector';
import { JiraProjectUserSelector } from '../../packages/atlassian/menus/JiraProjectUserMenuSelector';
import { JiraSprintSelector } from '../../packages/atlassian/menus/JiraSprintSelector';

const modeOpts = [
    { label: 'Simple', value: 'simple' },
    { label: 'JQL', value: 'jql' },
];

export const SelectJiraIssuesFilterView = React.memo<{ jiraProjectId: string, onChange(jql: string) }>(({ jiraProjectId, onChange }) => {

    const [directJql, setDirectJql] = useState('');
    const [term, setTerm] = useState('');
    const [sprints, setSprints] = useState([] as JiraSprintData[]);
    const [issueTypes, setIssueTypes] = useState([] as JiraIssueTypeData[]);
    const [users, setUsers] = useState([] as JiraUserLiteData[]);
    const [mode, setMode] = useState(modeOpts[0].value);

    useEffect(() => {

        const keyFilter = `issuekey = "${term.toUpperCase()}"`;
        const textFilter = `text ~ "${term}"`;
        const termFilter = term.match(/[A-Z\d]+-\d+/) ? `(${textFilter} OR ${keyFilter})` : textFilter;

        const jql = [
            `project = ${jiraProjectId}`,
            term && termFilter,
            sprints.length && `sprint in (${sprints.map(x => x.id).join(',')})`,
            issueTypes.length && `issuetype in (${issueTypes.map(x => x.id).join(',')})`,
            users.length && `assignee in (${users.map(x => x.id).join(',')})`,
        ].filter(Boolean).join(' AND ');

        setDirectJql(jql);

    }, [term, sprints, issueTypes, users]);

    useEffect(() => {

        if (mode === 'simple') {
            const keyFilter = `issuekey = "${term.toUpperCase()}"`;
            const textFilter = `text ~ "${term}"`;
            const termFilter = term.match(/[A-Z\d]+-\d+/) ? `(${textFilter} OR ${keyFilter})` : textFilter;

            const jql = [
                `project = ${jiraProjectId}`,
                term && termFilter,
                sprints.length && `sprint in (${sprints.map(x => x.id).join(',')})`,
                issueTypes.length && `issuetype in (${issueTypes.map(x => x.id).join(',')})`,
                users.length && `assignee in (${users.map(x => x.id).join(',')})`,
            ].filter(Boolean).join(' AND ');

            onChange(jql);
        }
        else {
            onChange(directJql);
        }

    }, [mode, directJql, term, sprints, issueTypes, users, onChange]);

    return <>
        <Flexer flex="row" gap="1" align="center">
            {mode === 'simple' && <>
                <Flexer grow>
                    <Input placeholder="Search" value={term} onChange={setTerm} />
                </Flexer>
                <Flexer width="12" shrink>
                    <JiraSprintSelector jiraProjectId={jiraProjectId} selected={sprints} onChange={setSprints} />
                </Flexer>
                <Flexer width="12" shrink>
                    <JiraProjectIssueTypeSelector jiraProjectId={jiraProjectId} selected={issueTypes} onChange={setIssueTypes} />
                </Flexer>
                <Flexer width="12" shrink>
                    <JiraProjectUserSelector jiraProjectId={jiraProjectId} selected={users} onChange={setUsers} />
                </Flexer>
            </>}
            {mode === 'jql' &&
                <Flexer grow>
                    <Input placeholder="JQL Query" value={directJql} onChange={setDirectJql} />
                </Flexer>
            }
            <Flexer flex="row" center>
                <ButtonToggle size="md" options={modeOpts} selected={mode} onChange={setMode} />
            </Flexer>
        </Flexer>
    </>;

});
